import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";

const mobileAuthAtom = atom({} as any);

const useSetMobileAuthAtomAtom = () => useSetAtom(mobileAuthAtom);
const useMobileAuthAtomValue = () => useAtomValue(mobileAuthAtom);
const useMobileAuthAtom = () => useAtom(mobileAuthAtom);

export { useMobileAuthAtom, useMobileAuthAtomValue, useSetMobileAuthAtomAtom };
